import * as yup from "yup";
import TotalLeadIcon from "../../../assets/Images/Leads-Icon.svg";
import ActiveLeadIcon from "../../../assets/Images/ActiveLeads-Icon.svg";
import NewLeadIcon from "../../../assets/Images/NewLeads--Icon.svg";
import ClosedLeadIcon from "../../../assets/Images/ClosedLeads-Icon.svg";
export interface ILead {
  leadId?: number;
  pocId: number[];
  companyId: number;
  sourceId: number;
  statusId: number;
  assignedToUserId: number;
  leadStatus?: string;
  companyName?: string;
  pocName?: string;
  sourceName?: string;
  statusName?: string;
  assignedToUserName?: string;
  industry?: string;
  contact: string;
  website: string;
  email: string;
  whatsapp: string;
  createdAt?: string | null;
  leadStatusId?: number;
  statusReason?: string;
  statusReasonId?: number;
  assignedToUser?: string;
  createdBy?: string;
  countryCode?: string;
  salesStageId?: number;
  saleStage?: string;
  isAccepted?: boolean | null;
  reason?: string;
  disReason?: string;
  disqualifyReason?: string;
  isRevoked?: boolean;
  revokedAt?: string | null;
  revokedByUserId?: number | null;
  revokeReason?: string | null;
}

export interface ILeadTable {
  leads: ILead[];
  totalCount: number;
}

export const defaultLead = {
  pocId: [],
  companyId: 0,
  sourceId: 0,
  statusId: 0,
  assignedToUserId: 0,
  contact: "",
  website: "",
  email: "",
  whatsapp: "",
} satisfies ILead;

export const LeadSchema = yup.object({
  pocId: yup.array().min(1, "Select at least one POC").required(),
  sourceId: yup
    .number()
    .typeError("Source is required")
    .required("Source is required"),
  statusId: yup
    .number()
    .typeError("Status is required")
    .required("Status is required"),
  assignedToUserId: yup
    .number()
    .typeError("User is required")
    .required("User is required"),
});

export const cards = [
  { label: "Total Leads", value: 12, percent: "+2%", icon: TotalLeadIcon },
  { label: "Active Leads", value: 7, percent: "+12%", icon: ActiveLeadIcon },
  { label: "New Leads", value: 5, percent: "+10%", icon: NewLeadIcon },
  { label: "Closed Leads", value: 20, percent: "+11%", icon: ClosedLeadIcon },
];

export const getStatusStyle = (status: string) => {
  switch (status) {
    case "New Lead":
    case "Lead Created":
      return { bg: "#DBEAFE", color: "#1D4ED8" };
    case "All":
      return { bg: "#EDE9FE", color: "#7C3AED" };

    case "Assigned":
      return { bg: "#EDE9FE", color: "#7C3AED" };

    case "Contacted":
    case "Initial Contact":
      return { bg: "#CFFAFE", color: "#0891B2" };

    case "Requirement Gathering":
      return { bg: "#CCFBF1", color: "#0F766E" };

    case "Qualified":
      return { bg: "#DCFCE7", color: "#15803D" };

    case "Invalid":
    case "Unqualified":
      return { bg: "#FEE2E2", color: "#B91C1C" };

    case "On Hold":
      return { bg: "#FFFFFF", color: "#6B7280" };

    case "No Response":
      return { bg: "#FFEDD5", color: "#9B7280" };

    case "Reminders1":
    case "Reminders":
      return { bg: "#FEF3C7", color: "#A16207" };
    case "Follow-Up-Done":
      return { bg: "#FEF3C7", color: "#A16207" };

    case "Negotiation":
      return { bg: "#FEF3C7", color: "#D97706" };

    case "Decision Pending":
      return { bg: "#FFF7ED", color: "#EA580C" };

    case "Under Review":
      return { bg: "#EEF2FF", color: "#4338CA" };

    case "Won":
    case "Closed Won":
      return { bg: "#DCFCE7", color: "#16A34A" };

    case "Lost":
    case "Rejected":
    case "Closed Lost":
      return { bg: "#FEE2E2", color: "#DC2626" };

    case "Not Intrested":
      return { bg: "#FEF2F2", color: "#B91C1C" };

    case "Budget Issue":
      return { bg: "#FFEDD5", color: "#C2410C" };

    case "Duplicate":
      return { bg: "#FFF7ED", color: "#C2410C" };

    case "Proposal Preparation":
      return { bg: "#FED7AA", color: "#7C2D12" };

    case "Proposal Sent":
      return { bg: "#FFEDD5", color: "#EA580C" };

    case "Assigned":
      return { bg: "#E0E7FF", color: "#3730A3" };
    case "Meeting Scheduled":
      return { bg: "#E0F2FE", color: "#0369A1" };

    case "Meeting Done":
      return { bg: "#D1FAE5", color: "#047857" };

    case "Proposal Shared":
      return { bg: "#E0E7FF", color: "#4338CA" };
    default:
      return { bg: "#EDF2F7", color: "#4A5568" };
  }
};

export const getStatusRank = (statusName: string): number => {
  const name = (statusName || "").trim().toLowerCase();
  if (name === "all" || name === "all leads" || name === "all") return 1;

  if (name === "new lead" || name === "new leads" || name === "lead created") return 2;
  if (name === "under review") return 3;
  if (name === "assigned" || name === "assigned lead") return 4;
  if (name === "contacted" || name === "contacted bdm" || name === "initial contact") return 5;
  if (name === "Follow-up" || name === "follow-up" || name === "follow-up1") return 6;

  if (name === "Reminders" || name === "reminders" || name === "Reminders1") return 7;
  if (name === "follow up done" || name === "follow-up-done") return 7; if (name === "meeting scheduled") return 8;
  if (name === "meeting done") return 9;
  if (name === "requirement gathering") return 10;
  if (name === "proposal shared" || name === "proposal sent" || name === "proposal preparation") return 11;
  if (name === "negotiation") return 12;
  if (name === "decision pending") return 13;
  if (name === "won" || name === "closed won" || name === "qualified") return 14;
  if (name === "lost" || name === "closed lost") return 15;
  if (name === "not interested" || name === "not intrested") return 16;
  if (name === "reassigned") return 17;
  if (name === "rejected") return 18;
  if (name === "invalid" || name === "unqualified") return 19;

  if (name === "on hold") return 20;
  if (name === "no response") return 21;
  if (name === "duplicate" || name === "duplicate converted") return 22;

  return 100;
};

